import utils from 'utils';
import {
  DATA_ROOM_ARCHIVE_INSTANCE_STEP,
  DATA_ROOM_ARCHIVE_INSTANCE_TYPE,
  DataRoomArchiveInstanceStep,
  DataRoomArchiveInstanceType,
} from './types';

export const STEPS_LENGTH = Object.values(
  DATA_ROOM_ARCHIVE_INSTANCE_STEP,
).length;

export const checkIsArchiveCompleted = (step: DataRoomArchiveInstanceStep) =>
  step === DATA_ROOM_ARCHIVE_INSTANCE_STEP.COMPLETED;

export const checkIsArchiveSellSide = (type: DataRoomArchiveInstanceType) =>
  type === DATA_ROOM_ARCHIVE_INSTANCE_TYPE.SELL_SIDE;

export const getFormattedDate = (date: Date) =>
  utils.dateFormat(date, 'dd/mm/yyyy');
